import hexagon_background from 'images/hexagon_background.svg'

const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.primaryMain,
    backgroundImage: `url(${hexagon_background})`,
    backgroundSize: '150%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
})

export default styles
